import type { AppProps } from 'next/app'
import { appWithTranslation } from "next-i18next";

import { RootLayout } from "components/layouts/RootLayout";
import { PageLoading } from "common/ui/PageLoading";
import { PageTransitionSpinner } from "common/elements/PageTransitionSpinner";
import { ErrorBoundary } from "common/components/ErrorBoundary";
import { PostHogProvider } from "common/providers/PostHogProvider";
import { SWRGlobalConfig } from "common/providers/SWRGlobalConfig";
import { IubendaProvider } from "common/providers/IubendaProvider";
import { GoogleApiProvider } from "common/providers/GoogleApiProvider";

import { useAuth } from "common/middleware/hooks/auth.hooks";

import "common/styles/globals.scss";

function App({ Component, pageProps }: AppProps) {
  const isAuthenticated = useAuth({ redirectToAuth: true });

  return (
    <GoogleApiProvider>
      <PostHogProvider>
        <IubendaProvider>
          {isAuthenticated ? (
            <ErrorBoundary>
              <SWRGlobalConfig>
                <RootLayout>
                  <PageTransitionSpinner />
                  <Component {...pageProps} />
                </RootLayout>
              </SWRGlobalConfig>
            </ErrorBoundary>
          ) : (
            <PageLoading />
          )}
        </IubendaProvider>
      </PostHogProvider>
    </GoogleApiProvider>
  )
}

export default appWithTranslation(App);
